var _path, _g, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMicrophoneKaraoke(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1369_20350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 2,
    width: 22,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.017 18.7332C31.537 21.2632 34.413 23.2772 37.299 24.0012C39.287 23.5692 41.259 22.7892 42.797 21.2452C47.125 16.9012 47.059 9.78924 42.651 5.36324C38.241 0.937239 31.157 0.87124 26.827 5.21524C25.227 6.82124 24.403 8.70524 24.001 10.7892C24.767 13.3232 26.655 16.3612 29.017 18.7332Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1369_20350)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "current"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1369_20350",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 14,
    width: 32,
    height: 33
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.81865 45.811C5.90065 46.405 4.46465 45.509 3.47665 44.525C2.49265 43.537 1.59665 42.101 2.19065 41.183L21.5886 14.399C21.6186 14.357 21.6906 14.309 21.7466 14.285C21.7946 14.257 21.8466 14.239 21.9026 14.247C21.9846 14.253 22.0566 14.299 22.1006 14.369C23.6446 16.931 25.5866 19.371 27.1046 20.899C28.6326 22.417 31.0706 24.359 33.6346 25.903C33.7046 25.947 33.7506 26.021 33.7566 26.101C33.7646 26.157 33.7466 26.209 33.7186 26.257C33.6946 26.313 33.6466 26.383 33.6046 26.415L6.81865 45.811ZM18.0006 27.001C18.0006 28.657 19.3446 30.001 21.0006 30.001C22.6566 30.001 24.0006 28.657 24.0006 27.001C24.0006 25.345 22.6566 24.001 21.0006 24.001C19.3446 24.001 18.0006 25.345 18.0006 27.001Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1369_20350)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "current"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMicrophoneKaraoke);
export default __webpack_public_path__ + "static/media/ic_microphone_karaoke.a0a8db6aca14d89c423ab9a52ef5ab2b.svg";
export { ForwardRef as ReactComponent };